import type { PermissionCatalogEntry } from "./useRoleEditor";
import type { GroupedPermissions } from "./PermissionCheckboxGroup";

export function groupByGroup(catalog: PermissionCatalogEntry[]): GroupedPermissions[] {
  const order: string[] = [];
  const byGroup = new Map<string, PermissionCatalogEntry[]>();
  for (const entry of catalog) {
    const existing = byGroup.get(entry.group);
    if (existing === undefined) {
      byGroup.set(entry.group, [entry]);
      order.push(entry.group);
    } else {
      existing.push(entry);
    }
  }
  return order.map((group) => ({ group, entries: byGroup.get(group) as PermissionCatalogEntry[] }));
}
